<div *ngIf="auth.authenticated && auth?.user?.midStageAccountsAccess;else other_content;">

  <!-- Page Header -->
  <h2>Mid-Stage Account Ranks</h2>

  <!-- Displays before page has finished loading -->
  <p *ngIf="!allRankings">
    <em>Loading...</em>
  </p>

  <!-- Current User logged in -->
  <h5 *ngIf="allRankings?.length > 0">
    <span>Showing data for user: <b>{{ allRankings[0].fiservUserId }}</b></span>
  </h5>

  <br />

  <!-- Horizontal grid of "print this page" button, last refresh date, and manual refresh button -->
  <div *ngIf="allRankings" class="rankings">
    <div class="heading">
      <div>
        <button type="button" class="btn btn-primary" media="all" onclick="window.print()">Print This Page</button>
      </div>
      <ng-container *ngIf="allRankings?.length > 0;else other_content;">
        <div class="currentHour">
          <span class="rankInfoHeading">Queue Last Refreshed On</span>
          <br />
          {{ allRankings[0].asOfDate | date: 'M/d/yy' }}
        </div>
      </ng-container>
      <ng-template #other_content>
        <div class="currentHour">
          <span class="rankInfoHeading">Last Data Refreshed On</span>
          <br />
          NO RECORDS
        </div>
      </ng-template>
    </div>

    <!-- Creates Table -->
    <table class='table' *ngIf="allRankings">
      <thead>
        <tr>

          <!-- Column Labels -->
          <th style="text-align: center">Call Order</th>
          <th style="text-align: center">Account Number</th>
          <th style="text-align: center">Attempts</th>
          <th>Done For The Day?</th>
          <th>Notes</th>
          <th style="text-align: center">DPD</th>
          <th style="text-align:center">Last RPC</th>
        </tr>
      </thead>

      <!-- Table Body Content -->
      <tbody>

        <!-- For loop spanning length of rankings -->
        <ng-container *ngFor="let ranking of allRankings; let isOdd=odd; let i=index;">

          <!-- Accounts to be worked  -->
          <ng-container *ngIf="ranking.futureDated != 1 && ranking.textEmailFlag != 1 && ranking.done != 1">
            <tr [class.odd]="isOdd">

              <!-- Call Order -->
              <td style="text-align: center">
                <span>{{ i + 1 }}</span>
              </td>

              <!-- Creates a button with account number: red if DPD is greater than 50, white otherwise -->
              <ng-container *ngIf="currentHour >= ranking.callAfter && currentHour < ranking.callBefore; else gray_accountNumber">
                <ng-container *ngIf="ranking.dpd >= 50 && ranking.dpd <= 60; else color_default1;">
                  <td style="text-align: center">
                    <button type="button" class="btn btn-danger" (click)='popScreen(ranking, i)'>{{ ranking.accountNumber }}</button>
                  </td>
                </ng-container>
                <ng-template #color_default1>
                  <td style="text-align: center">
                    <button type="button" class="btn btn-default" (click)='popScreen(ranking, i)'>{{ ranking.accountNumber }}</button>
                  </td>
                </ng-template>

                <!-- Initializes Attempts column values to 0 -->
                <td style="text-align: center">
                  <span>{{ ranking.attempts ? ranking.attempts : 0 }}</span>
                </td>

                <!-- Creates a clickable green button for completed accounts -->
                <td>
                  <button type="button" class="btn btn-success" (click)='markDone(ranking, i)'>Done For The Day</button>
                </td>
              </ng-container>

              <!-- Creates a disabled button with account number: red if DPD is greater than 50, white otherwise -->
              <ng-template #gray_accountNumber>
                <ng-container *ngIf="ranking.dpd >= 50 && ranking.dpd <= 60; else color_default2;">
                  <td style="text-align: center">
                    <button type="button" class="btn btn-danger" (click)='popScreen(ranking, i)' disabled>{{ ranking.accountNumber }}</button>
                  </td>
                </ng-container>
                <ng-template #color_default2>
                  <td style="text-align: center">
                    <button type="button" class="btn btn-default" (click)='popScreen(ranking, i)' disabled>{{ ranking.accountNumber }}</button>
                  </td>
                </ng-template>

                <!-- Initializes Attempts column values to 0 -->
                <td style="text-align: center">
                  <span>{{ ranking.attempts ? ranking.attempts : 0 }}</span>
                </td>
                <td>
                  <button type="button" class="btn btn-success" (click)='markDone(ranking, i)' disabled>Done For The Day</button>
                </td>
              </ng-template>

              <!-- Fills in Notes column with correspoding data from database -->
              <td>
                <span>{{ ranking.notes }}</span>
              </td>

              <!-- Fills in DPD column with correspoding data from database -->
              <td style="text-align: center">
                <span>{{ ranking.dpd }}</span>
              </td>

              <!-- Fills in Last RPC column with correspoding data from database -->
              <td style="text-align: center">
                <span>{{ ranking.lastRPC | date: 'M/d/yy' }}</span>
              </td>

            </tr>
            </ng-container>
            </ng-container>

            <!-- Accounts not to be worked on (accounts marked for the future, with text/email flags and/or already done for the day) -->
            <ng-container *ngFor="let ranking of allRankings; let isOdd=odd; let i=index;">
              <ng-container *ngIf="ranking.futureDated == 1 || ranking.textEmailFlag == 1 || ranking.done == 1">
                <tr [class.odd]="isOdd">

                  <!-- Call Order -->
                  <td style="text-align: center">
                    <span>{{ i + 1 }}</span>
                  </td>

                  <!-- Creates a disabled button with account number: red if DPD is greater than 50, white otherwise -->
                  <ng-container>
                    <ng-container *ngIf="ranking.dpd >= 50 && ranking.dpd <= 60; else color_default3;">
                      <td style="text-align: center">
                        <button type="button" class="btn btn-danger" (click)='popScreen(ranking, i)' disabled>{{ ranking.accountNumber }}</button>
                      </td>
                    </ng-container>
                    <ng-template #color_default3>
                      <td style="text-align: center">
                        <button type="button" class="btn btn-default" (click)='popScreen(ranking, i)' disabled>{{ ranking.accountNumber }}</button>
                      </td>
                    </ng-template>

                    <!-- Initializes Attempts column values to 0 -->
                    <td style="text-align: center">
                      <span>{{ ranking.attempts ? ranking.attempts : 0 }}</span>
                    </td>

                    <!-- Creates a disabled unclickable green button for completed accounts -->
                    <td>
                      <button type="button" class="btn btn-success" (click)='markDone(ranking, i)' disabled>Done For The Day</button>
                    </td>
                  </ng-container>

                  <!-- Fills in Notes column with correspoding data from database -->
                  <td>
                    <span>{{ ranking.notes }}</span>
                  </td>

                  <!-- Fills in DPD column with correspoding data from database -->
                  <td style="text-align: center">
                    <span>{{ ranking.dpd }}</span>
                  </td>

                  <!-- Fills in Last RPC column with correspoding data from database -->
                  <td style="text-align: center">
                    <span>{{ ranking.lastRPC | date: 'M/d/yy' }}</span>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
</tbody>
    </table>
  </div>
</div>

<ng-template #other_content>
  <div *ngIf="!auth.authenticated; else unauthorized;">
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />

    <div class="midstage">
      <h1>Please <a (click)="auth.signIn()" [routerLink]="">sign in</a> to continue.</h1>
    </div>

    <br />
    <br />
    <br />
    <br />

    <div class="midstage">
      <img class="logo" src="assets/CollectorAssistantToolLogoNavy.png" />
    </div>

  </div>
  <ng-template #unauthorized>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <h2 class="notAuth">You are not authorized to view this page. Please contact your manager.</h2>
  </ng-template>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/mid-stage-account-ranks/mid-stage-account-ranks.component.html